'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavLink = exports.NavLink = (0, _systemComponents2.default)({
  is: 'a',
  color: 'inherit',
  bg: 'transparent',
  fontSize: 1,
  fontWeight: 'bold',
  p: 2
}, function (props) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:disabled': {
      opacity: 1 / 4
    }
  };
}, 'width');

NavLink.displayName = 'NavLink';

exports.default = NavLink;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/NavLink.js
// module id = 111
// module chunks = 35783957827783 114276838955818 225143243664639